import './banner.styl';

import React from 'react';
import {connect} from 'react-redux';
import cookie from 'react-cookie';
import {FormattedMessage} from 'react-intl';
import Icon from '../icon/Icon';

class Banner extends React.Component {
  static contextTypes = {
    intl: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      disable: !!cookie.load('disable_banner')
    };
  }

  onClose(e) {
    e.preventDefault();
    e.stopPropagation();
    cookie.save('disable_banner', 1, {path: '/', maxAge: 30 * 24 * 3600});
    this.setState({disable: true});
  }

  render() {
    const {disable} = this.state;
    const {useragent, isMobile} = this.props;
    const {intl: {locale}} = this.context;

    return (
      <div className="banner">
        {!disable && !useragent.chrome &&
          <a
            className="banner__banner"
            href={locale === 'zh'
              ? 'http://browser.qq.com/'
              : 'https://www.google.ru/chrome/browser/desktop/index.html'}
            target="_blank"
            rel="nofollow"
          >
            <div className="banner__inner">
              <div className="banner__logo">
                <img
                  src={locale === 'zh'
                    ? require('./qq-browser.png')
                    : require('./chrome.png')
                  }
                  className="banner__logo-src"
                />
              </div>
              <div className="banner__container">
                <div className="banner__container-title">
                  {locale === 'zh'
                    ? 'QQ Browser'
                    : 'Google Chrome'
                  }

                </div>
                <div className="banner__container-text">
                  <FormattedMessage id="banner.text" />
                </div>
              </div>
              <div className="banner__close" onClick={::this.onClose}>
                <Icon name="cross" size="s" />
              </div>
            </div>
          </a>
        }
      </div>
    );
  }
}


export default connect(state => ({
  appType: state.config.appType,
  useragent: state.device.useragent,
  device: state.device.device,
  isMobile: state.device.isMobile
}))(Banner);



// WEBPACK FOOTER //
// ./src/client/components/banner/Banner.js